import React from 'react';
import { motion } from 'framer-motion';
import { Star, PlayCircle, ShieldCheck } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { CTAButton } from './CTAButton';
interface HeroProps {
  cartLink: string;
}
export const Hero: React.FC<HeroProps> = ({
  cartLink
}) => {
  return <section className="bg-brand-rose py-12 md:py-20 px-4 overflow-hidden" data-id="element-113">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-114">
        {/* Left Column: Copy & CTA */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col gap-6" data-id="element-115">
          <div className="inline-flex items-center gap-2 bg-brand-blush text-brand-wine px-4 py-1.5 rounded-full w-fit text-sm font-semibold" data-id="element-116">
            <span className="w-2 h-2 rounded-full bg-brand-wine animate-pulse" data-id="element-117"></span>
            +1578 Descargas
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-brand-charcoal" data-id="element-118">
            Dejar de Sobrepensar y Convertirte en la Mujer Que Él Persigue
          </h1>

          <p className="text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-119">
            Presentando La Guía Definitiva Para cambiar la dinámica emocional a
            tu favor.
          </p>

          {/* Trust Rating */}
          <div className="flex items-center gap-3" data-id="element-120">
            <div className="flex text-brand-gold" data-id="element-121">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-122" />)}
            </div>
            <span className="text-sm font-medium text-gray-600 flex items-center gap-1" data-id="element-123">
              4.9/5 <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-124" /> Compras
              Verificadas
            </span>
          </div>

          {/* Price Block */}
          <div className="bg-white/60 backdrop-blur-sm p-6 rounded-2xl border border-brand-blush mt-4" data-id="element-125">
            <div className="flex flex-col gap-1 mb-4" data-id="element-126">
              <span className="text-gray-500 font-medium" data-id="element-127">
                Antes: <PriceDisplay basePriceARS={40000} strikeThrough data-id="element-128" />
              </span>
              <div className="flex items-baseline gap-3" data-id="element-129">
                <span className="text-lg font-bold text-brand-wine" data-id="element-130">HOY:</span>
                <PriceDisplay basePriceARS={25990} className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal" data-id="element-131" />
              </div>
            </div>

            <CTAButton href={cartLink} fullWidth data-id="element-132">
              Obtener Acceso Instantáneo Ahora
            </CTAButton>

            <p className="text-xs text-center text-gray-500 mt-3 flex items-center justify-center gap-1" data-id="element-133">
              <ShieldCheck className="w-3 h-3" data-id="element-134" /> Pago único. Acceso inmediato.
            </p>
          </div>
        </motion.div>

        {/* Right Column: Video Placeholder */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative" data-id="element-135">
          <div className="aspect-[4/5] md:aspect-square rounded-3xl overflow-hidden shadow-2xl relative group cursor-pointer" data-id="element-136">
            <img src="https://images.unsplash.com/photo-1516726817505-f5ed825624d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Mujer elegante y calmada" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-137" />
            <div className="absolute inset-0 bg-brand-wine/20 group-hover:bg-brand-wine/10 transition-colors duration-300" data-id="element-138" />

            {/* Play Button Overlay */}
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-4" data-id="element-139">
              <div className="w-20 h-20 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform duration-300" data-id="element-140">
                <PlayCircle className="w-10 h-10 text-brand-wine ml-1" data-id="element-141" />
              </div>
              <div className="bg-black/50 backdrop-blur-md text-white px-4 py-2 rounded-full text-sm font-medium" data-id="element-142">
                (Asegúrate de tener el sonido activado)
              </div>
            </div>
          </div>

          <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-brand-gold/20 rounded-full blur-3xl -z-10" data-id="element-143" />
          <div className="absolute -top-6 -left-6 w-32 h-32 bg-brand-wine/10 rounded-full blur-3xl -z-10" data-id="element-144" />
        </motion.div>
      </div>
    </section>;
};